// extracted by mini-css-extract-plugin
module.exports = {"root":"comtrols-add-prev_root__1XyAE"};